import React from 'react';
import { FormattedMessage } from 'react-intl';
import NegativeToast from '@/components/toasts/NegativeToast';

const UserGroupsAssignErrorToast = ({ groups, users }) => (
  <NegativeToast className="aridhia-user-groups-assign-error-toast" icon="times circle">
    {users.length === 1 && (
      <FormattedMessage id="users.groups.toast.error.user" values={{ name: users[0].name, count: groups.length }} />
    )}
    {users.length > 1 && (
      <FormattedMessage id="users.groups.toast.error.group" values={{ name: groups[0].name, count: users.length }} />
    )}
  </NegativeToast>
);

export default UserGroupsAssignErrorToast;
